<template>
  <div>
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-navbar></layout-navbar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">

        <!-- Page Content -->
        <div class="content container-fluid">

          <div class="crms-title row bg-white">
            <div class="col  p-0">
              <h3 class="page-title m-0">
                        <span class="page-title-icon bg-gradient-primary text-white mr-2">
                          <i class="feather-grid"></i>
                        </span> Website Audit </h3>
            </div>
            <div class="col p-0 text-right">
              <ul class="breadcrumb bg-white float-right m-0 pl-0 pr-0">
                <li class="breadcrumb-item"><router-link to="/index">DSMS</router-link></li>
                <li class="breadcrumb-item active">Website Audit</li>
              </ul>
            </div>
          </div>
          <!-- Page Header -->
          <div class="page-header pt-3 mb-0 ">
            <div class="row">
              <div class="col-xl-6 d-flex">
                <div class="card flex-fill">
                  <div class="card-header">
                    <h4 class="card-title mb-0">Website Details</h4>
                  </div>
                  <div class="card-body">
                    <div class="form-group row">
                      <label class="col-lg-4 col-form-label">Mandant<span class="text-danger">*</span></label>
                      <div class="col-lg-8">
                        <input type="text" class="form-control" v-model="mandantName">
                        <span class="error-message text-danger" v-show="v$.mandantName.$errors.length>0">{{ $t('required_field') }}</span>
                      </div>
                      <div class="form-text">Die Haupt-URL der zu prüfenden Website</div>
                    </div>
                    <div class="form-group row">
                      <label class="col-lg-4 col-form-label">Haupt-Website-URL<span class="text-danger">*</span></label>
                      <div class="col-lg-8">
                        <input type="text" class="form-control" v-model="mainUrl" placeholder="https://example.com"/>
                        <span class="error-message text-danger" v-show="v$.mainUrl.$errors.length>0">{{ $t('required_field') }}</span>
                      </div>
                      <div class="form-text">Die Haupt-URL der zu prüfenden Website</div>
                    </div>
                    <div class="form-group row">
                      <label class="col-lg-4 col-form-label">Datenschutzrichtlinien-URL<span class="text-danger">*</span></label>
                      <div class="col-lg-8">
                        <input type="text" class="form-control" v-model="privacyPolicyUrl" placeholder="https://example.com/datenschutz" />
                        <span class="error-message text-danger" v-show="v$.privacyPolicyUrl.$errors.length>0">{{ $t('required_field') }}</span>
                      </div>
                      <div class="form-text">URL zur Datenschutzrichtlinien-Seite der Website</div>
                    </div>
                    <div class="form-group row">
                      <label class="col-lg-4 col-form-label">Impressums-URL<span class="text-danger">*</span></label>
                      <div class="col-lg-8">
                        <input type="text" class="form-control" v-model="legalNoticeUrl" placeholder="https://example.com/impressum" />
                        <span class="error-message text-danger" v-show="v$.legalNoticeUrl.$errors.length>0">{{ $t('required_field') }}</span>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-lg-4 col-form-label">Geschützte Berufsbezeichnung</label>
                      <div class="col-lg-8">
                        <div class="checkbox">
                          <label>
                            <input type="checkbox" name="protected_professional_title" checked v-model="protectedProfessionalTitle"> Geschützte Berufsbezeichnung
                          </label>
                        </div>
                      </div>
                      <div class="form-text">Führt die Website eine geschützte Berufsbezeichnung?</div>
                    </div>
                    <div class="form-group row">
                      <label class="col-lg-4 col-form-label">Besondere Kategorie pbD</label>
                      <div class="col-lg-8">
                        <div class="checkbox">
                          <label>
                            <input type="checkbox" name="special_category_pbd" checked v-model="specialCategoryPbd">Besondere Kategorie pbD
                          </label>
                        </div>
                      </div>
                      <div class="form-text">Verarbeitet die Website besondere Kategorien personenbezogener Daten?</div>
                    </div>
                    <div class="form-group row">
                      <label class="col-lg-4 col-form-label">journalistisch-redaktionelle Inhalte</label>
                      <div class="col-lg-8">
                        <div class="checkbox">
                          <label>
                            <input type="checkbox" name="journalist_content" checked v-model="journalistContent"> journalistisch-redaktionelle Inhalte
                          </label>
                        </div>
                      </div>
                      <div class="form-text">Wird der Dienst journalistisch-redaktionelle Inhalte anbieten?</div>
                    </div>
                    <div class="form-group row">
                      <label class="col-lg-4 col-form-label">GAP Aufnahme</label>
                      <div class="col-lg-8">
                        <div class="checkbox">
                          <label>
                            <input type="checkbox" name="gap_input" v-model="gapInput"> GAP Aufnahme
                          </label>
                        </div>
                      </div>
                      <div class="form-text">Eintrag wird in GAP aufgenommen. Maßnahme wird immer generiert unabhängig von dieser Option!</div>
                    </div>
                    <div class="alert alert-info">
                      <h6>Folgendes wird geprüft:</h6>
                      <ul class="mb-0">
                        <li>Website-Screenshot mit Playwright</li>
                        <li>Cookie-Analyse (Session vs. persistent, Drittanbieter)</li>
                        <li>Erkennung und Kategorisierung von Trackern</li>
                        <li>Funktionalität des Consent-Banners</li>
                        <li>Überprüfung der Datenschutzrichtlinien-Konformität</li>
                        <li>Vollständigkeit des Impressums</li>
                        <li>SSL/TLS-Sicherheitsanalyse</li>
                      </ul>
                    </div>
                    <div class="text-right">
                        <button class="btn btn-primary" @click="startAudit">Audit starten</button>
                      <!--</router-link>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { service, baseURL } from '@/utils/request'
import {mapState} from 'vuex'
import {required} from "@vuelidate/validators";
import {useVuelidate} from "@vuelidate/core";
import {surveyToExcel, makeAVCoverSheet} from '@/utils/exportToExcel'
import {ajaxErrorMessage} from "@/utils";

export default {
  name: 'createWebsiteAudit',
  data: function() {
    return {
      protectedProfessionalTitle: false,
      specialCategoryPbd: false,
      journalistContent: false,
      mainUrl: '',
      privacyPolicyUrl: '',
      legalNoticeUrl: '',
      mandantName: '',
      gapInput: true,
    }
  },
  computed: {...mapState({accountid: state => state.account.accountid, accountName: state => state.account.name, userID: state => state.user.id, userFullname: state => state.user.name, username: state => state.user.username}), },
  validations() {
    return {
      mandantName: {required, $lazy: true},
      mainUrl: {required, $lazy: true},
      privacyPolicyUrl: {required, $lazy: true},
      legalNoticeUrl: {required, $lazy: true},
    }
  },
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  watch:{
  },
  mounted() {
    this.mandantName = this.accountName
  },
  methods: {
    startAudit: async function() {
      const isValid = await this.v$.$validate()
      if (!isValid) {
        this.$vToastify.error('Bitte fehlende Felder vervollständigen!')
        return
      }
      this.btnDisabled = true
      service.request({
        url: 'todos/v1/create_website_audit/',
        method: 'POST',
        responseType: 'json',
        data: {
          main_url: this.mainUrl,
          privacy_policy_url: this.privacyPolicyUrl,
          legal_notice_url: this.legalNoticeUrl,
          protected_professional_title: this.protectedProfessionalTitle,
          special_category_pbd: this.specialCategoryPbd,
          journalist_content: this.journalistContent,
          dsms_client_id: this.accountid,
          mandant_name: this.mandantName,
          auditor_name: this.userFullname,
          username: this.username,
          gap_input: this.gapInput,
        }
      }).then(() => {
        this.v$.$reset()
        this.btnDisabled = false
        this.$router.push({name: 'website-audits'})
        this.$vToastify.success('Website Audit ist erfolgreich gestartet!')
      }).catch(error => {
        this.btnDisabled = false
        this.$vToastify.error(ajaxErrorMessage(error))
      })
    },
  }
}
</script>

<style scoped>

</style>
